import { DefaultService } from '@/services/DefaultService';

export default class ContatoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAllVendas(column, order, page, limit, situacao, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/cliente/contato.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAgro(column, order, page, limit, situacao, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/cliente/contato.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

	findAllCombo(params) {
		return this.findAllComboSituacao(1, params);
	}
    findAllComboSituacao(situacao = 1, ...params) {
		return this._http.get(encodeURI(`${this._env}/agro/cliente/contato/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    updateSituacaoVendas(contato) {
        return this._http.post(`${this._env}/ven/cliente/contato/updatesituacao`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(contato) {
        return this._http.post(`${this._env}/agro/cliente/contato/updatesituacao`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findVendas(id) {
        return this._http.get(`${this._env}/ven/cliente/contato/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAgro(id) {
        return this._http.get(`${this._env}/agro/cliente/contato/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveVendas(contato) {
        return this._http.post(`${this._env}/ven/cliente/contato`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(contato) {
        return this._http.post(`${this._env}/agro/cliente/contato`, contato, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}